import { render, staticRenderFns } from "./ot-document-details.vue?vue&type=template&id=b7577bea&scoped=true&"
import script from "./ot-document-details.vue?vue&type=script&lang=ts&"
export * from "./ot-document-details.vue?vue&type=script&lang=ts&"
import style0 from "./ot-document-details.vue?vue&type=style&index=0&id=b7577bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7577bea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VProgressLinear,VTooltip})
